<template>
  <div id="adminChats">
    <div class="content">
      <div class="ChatBtn me-lg-n16">
        <v-btn class="mb-lg-2 pe-md-12 pe-xl-9" rounded color="var(--color-blue)" style="color: var(--color-deepwhite)" :to="`/admin/adminChats`">
          <v-icon class="me-1">mdi-account-outline</v-icon>
        </v-btn>
        <v-btn rounded class="pe-md-12 pe-xl-9" color="var(--color-blue)" style="color: var(--color-deepwhite)" :to="`/admin/adminChatsO`">
          <v-icon class="me-1">mdi-account-tie-outline</v-icon>
        </v-btn>
      </div>
      <div class="chatlist">
        <v-card rounded class="mx-auto" max-width="300" tile>
          <v-list rounded color="var(--color-deepwhite)" class="list">
            <v-subheader style="font-weight: 700">業主列表</v-subheader>
            <v-list-item-group v-model="selected" color="var(--color-chatdeepblue)">
              <v-list-item v-for="owner in getowner" :key="owner.username" class="mb-3">
                <v-avatar size="40" class="me-5">
                  <v-img :src="'https://source.boringavatars.com/beam/120/' + owner.account"></v-img>
                </v-avatar>
                <v-list-item-content>
                  <v-list-item-title v-text="owner.ownername" style="font-weight: 700"></v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list-item-group>
          </v-list>
        </v-card>
      </div>
      <div class="main">
        <AdminChat />
      </div>
    </div>
  </div>
</template>

<script>
  import AdminChat from '../components/AdminChat.vue'
  export default {
    components: { AdminChat },
    data() {
      return {
        getowner: []
      }
    },
    async created() {
      try {
        console.log(this.user.token)
        const { data } = await this.api.get('/owners/admin', {
          headers: {
            authorization: 'Bearer ' + this.user.token
          }
        })
        this.getowner = data.result
      } catch (error) {
        this.$swal({
          icon: 'error',
          title: '失敗',
          text: '取得訊息失敗'
        })
      }
    },
    computed: {
      user() {
        return this.$store.getters['user/user']
      },
      owner() {
        return this.$store.getters['owner/owner']
      }
    },
    methods: {
      userlogout() {
        this.$store.dispatch('user/userlogout')
      },
      ownerlogout() {
        // 連到的是 actions 裡的 ownerlogout
        this.$store.dispatch('owner/ownerlogout')
      }
    }
  }
</script>
